<template>
  <div id="app">
    <div id="nav">
      <!-- <router-link v-if="authenticated" to="/Login" v-on:click.native="logout()" replace>Logout</router-link> -->
    </div>
    <!-- <StockChart/> -->
    <router-view @authenticated="setAuthenticated"/>
    <!-- <LoadingScreen :isLoading="isLoading" /> -->

    <ModalWindow></ModalWindow>
    <notifications position="bottom right" />
  </div>
</template>

<script>
import LoadingScreen from "./components/LoadingScreen";
import ModalWindow from "./components/ModalWindow";

export default {
  name: 'App',
  data() {
    return {
      authenticated: sessionStorage.getItem('authenticated') === 'true',
      isLoading: true,
    }
  },
  components: {
    ModalWindow,
    LoadingScreen
  },
  mounted() {
    if (!this.authenticated) {
      // this.$router.replace({ name: "Login" });
    }
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  },
  methods: {
    setAuthenticated(status) {
      this.authenticated = status;
    },
    logout() {
      this.authenticated = false;
    }
  }
}
</script>


<style>
  @import './assets/styles/main.css';
  @import './assets/styles/tables.css';
  @import './assets/styles/notification.css';
</style>



// WEBPACK FOOTER //
// src/App.vue